<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
          ><b-navbar-brand center>Quotation Library</b-navbar-brand>
        </b-navbar>
        <div>
          <b-collapse v-model="visible" id="collapse-2">
            <b-card>
              <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="clientMaster"
                    id="clientNamenew"
                    v-model="clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select  Client Name"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="shipmentType"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Sea / Air"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="flTypeList"
                    v-model="fclLclFilter"
                    option-value="flVal"
                    option-text="flText"
                    placeholder="Select FCL / LCL"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportType"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="finalAllPlaceDataPOR"
                    v-model="PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="finalAllPlaceDataPOD"
                    v-model="PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    :list="finalAllPlaceDataLP"
                    v-model="LPfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Load Port"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="containerList"
                    v-model="containerTypeFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </md-layout>
                <!-- <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <label for="blType">Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                  ></model-list-select>
                </md-layout> -->
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="shippingList"
                    v-model="ShippingLineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Search Enquiry"
                    id="newClientName"
                    name="newClientName"
                    v-model="enquiryFilter"
                  ></b-form-input>
                </md-layout>
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Search Quotation"
                    id="newClientName"
                    name="newClientName"
                    v-model="QuotationFilter"
                  ></b-form-input>
                </md-layout>
                <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="
                      getLocationList(
                        $event,
                        'Icd,Sea_Port_India',
                        'finalAllPlaceDataPickupLocation'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        'Icd,Sea_Port_India',
                        'finalAllPlaceDataPickupLocation'
                      )
                    "
                    :list="finalAllPlaceDataPickupLocation"
                    v-model="Pickupfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pickup Location"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100"></md-layout>
              </md-layout>
              <b-row class="mt-3 justify-content-center">
                <b-col cols="6" class="text-center">
                  <b-button size="sm" @click="filterSearch" variant="outline-primary"
                    >Search</b-button
                  >
                  <b-button
                    class="ml-3"
                    size="sm"
                    @click="clearFilter"
                    variant="outline-info"
                    >clear</b-button
                  >
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </div>

        <b-row class="mt-2">
          <b-col cols="3">
            <date-range-picker
              class="mr-2"
              :opens="openLeft"
              :always-show-calendars="showCal"
              v-model="dateRange"
              :startDate="startDate"
              :endDate="endDate"
            ></date-range-picker>
          </b-col>
          <b-col cols="1">
            <b-button
              variant="outline-dark"
              :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              >Filters</b-button
            >
          </b-col>
          <b-col cols="6" class="text-right">
            <!-- <b-button
              v-if="dateRange.endDate != '' && dateRange.startDate != ''"
              :disabled="ExcelBtnName0 != 'Export TPT Quotation' ? true : false"
              class="pull-right ml-1 mt-1"
              @click="getMultiReports('TPT_Quotation_LIST_EXCEL', 0)"
              size="sm"
              variant="warning"
              >{{ ExcelBtnName0 }}
              <b-spinner
                v-if="ExcelBtnName0 != 'Export TPT Quotation'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button> -->
            <b-button
              v-if="dateRange.endDate != '' && dateRange.startDate != ''"
              :disabled="ExcelBtnName1 != 'Export FF Quotation' ? true : false"
              class="pull-right ml-1 mt-1"
              @click="getMultiReports('FF_Quotation_LIST_EXCEL', 1)"
              size="sm"
              variant="warning"
              >{{ ExcelBtnName1 }}
              <b-spinner
                v-if="ExcelBtnName1 != 'Export FF Quotation'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>

            <b-button
              v-if="dateRange.endDate != '' && dateRange.startDate != ''"
              :disabled="ExcelBtnName2 != 'Export CC Quotation' ? true : false"
              class="pull-right ml-1 mt-1"
              @click="getMultiReports('CC_Quotation_LIST_EXCEL', 2)"
              size="sm"
              variant="warning"
              >{{ ExcelBtnName2 }}
              <b-spinner
                v-if="ExcelBtnName2 != 'Export CC Quotation'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>

            <b-button
              class="pull-right ml-1 mt-1"
              :disabled="ExcelBtnName3 != 'Export All Quotation' ? true : false"
              @click="getReports('All_Quotation_Excel')"
              size="sm"
              variant="warning"
              >{{ ExcelBtnName3 }}
              <b-spinner
                v-if="ExcelBtnName3 != 'Export All Quotation'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>

          <b-col cols="8">
            <input
              type="checkbox"
              @click="SelectAll(QuotationLibData)"
              v-model="isCheckAll"
            />
            <label>Select / Deselect All Count({{ this.All_tptQIds.length }})</label>
            <b-button
              v-if="All_tptQIds.length > 0"
              size="sm"
              @click="ExpiryMultiQuotation('Multi')"
              variant="outline-primary"
              >Expire Multi Quotation</b-button
            >
          </b-col>
          <b-col>
            <h5 class="text-muted pull-right" style="margin-bottom: 0 !important">
              <small v-if="isLoading == false">{{ totalRows }} Entries</small>
            </h5>
          </b-col>
          <b-col>
            <model-list-select
              :list="PaginationList"
              v-model="PaginationCount"
              option-value="pagv"
              option-text="pagt"
              placeholder="Select"
              @input="pagechangeData()"
            ></model-list-select>

            <!-- @select="pagechangeData(PaginationCount)" -->
          </b-col>
        </b-row>

        <div class="table-responsive tableMain mt-2">
          <b-table
            show-empty
            stacked="md"
            responsive
            :items="paginatedItems"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="tptTableId" slot-scope="row0">
              <!-- {{row0.item}} -->
              <!-- <input
                type="checkbox"
                v-bind:value="row0.item.tptQId"
                v-bind:id="row0.item.tptQSeries"
                v-model="All_tptQIds"
                @change="updateSelectAll($event, row0.item)"
              /> -->
              <input
                type="checkbox"
                v-bind:value="row0.item.QuotId"
                v-bind:id="row0.item.QuotNo"
                v-model="All_tptQIds"
                @change="updateSelectAll($event, row0.item)"
              />
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="tptQSeries" slot-scope="row1">
              <b>Quot. Type. : {{ row1.item.quotationType }}</b
              ><br />
              <b>Quot. No. : {{ row1.item.QuotNo }}</b
              ><br />
              <!-- <b>Quot. No. : {{ row1.item.tptQSeries }}</b><br /> -->
              <b>Quot. Date : {{ row1.item.created_at | moment }}</b
              ><br />
              <b>Validity. Date : {{ row1.item.validityDate | moment }}</b>
            </template>
            <template slot="mainEnquirySeries" slot-scope="row2">
              <span
                >Enquiry Type : {{ row2.item.jobType }} ({{
                  row2.item.shipmentType == "1" ? "Sea" : "Air"
                }}
                {{ row2.item.transportType }}) - {{ row2.item.containerInfo }}</span
              >
              <br />
              <span>Enquiry No. : {{ row2.item.mainEnquirySeries }}</span
              ><br />
              <span>Enquiry Date : {{ row2.item.EnqDate | moment }}</span>
            </template>

            <template slot="ClientName" slot-scope="row3">
              <b v-if="row3.item.shippingLine != '' && row3.item.shippingLine != null"
                >Client : {{ row3.item.ClientName }}</b
              ><br />
              <span v-if="row3.item.shippingLine != '' && row3.item.shippingLine != null">
                Shipping Line : {{ row3.item.shippingLine }}</span
              >
            </template>
            <template slot="containerType" slot-scope="row4">
              <span
                v-if="row4.item.containerType != '' && row4.item.containerType != null"
                >{{ row4.item.containerType }}<br
              /></span>
            </template>
            <template slot="pickupLocation" slot-scope="row5">
              <span
                v-if="row5.item.pickupLocation != '' && row5.item.pickupLocation != null"
                >Pickup : {{ row5.item.pickupLocation }}<br
              /></span>
              <span
                v-if="
                  row5.item.stuffingLocation != '' && row5.item.stuffingLocation != null
                "
                >Stuffing : {{ row5.item.stuffingLocation }}<br
              /></span>
              <span
                v-if="
                  row5.item.handoverLocation != '' && row5.item.handoverLocation != null
                "
                >Handover : {{ row5.item.handoverLocation }}<br
              /></span>
              <span v-if="row5.item.POR != '' && row5.item.POR != null">
                POR : {{ row5.item.POR }}<br
              /></span>
              <span v-if="row5.item.POL != '' && row5.item.POL != null">
                POL : {{ row5.item.POL }}<br
              /></span>
              <span v-if="row5.item.POD != '' && row5.item.POD != null">
                POD : {{ row5.item.POD }}<br
              /></span>
              <span v-if="row5.item.FPOD != '' && row5.item.FPOD != null">
                FPOD : {{ row5.item.FPOD }}<br
              /></span>
            </template>

            <template slot="Status" slot-scope="row6">
              <span v-if="row6.item.distance != '' && row6.item.distance != null"
                >Distance : {{ row6.item.distance }}<br
              /></span>
              <span
                v-if="
                  row6.item.dieselAllocated != '' && row6.item.dieselAllocated != null
                "
                >Diesel Allocated : {{ row6.item.dieselAllocated }}<br
              /></span>
              <span v-if="row6.item.dieselRate != '' && row6.item.dieselRate != null"
                >Diesel Rate : {{ row6.item.dieselRate }}<br
              /></span>
              <span v-if="row6.item.mileage != '' && row6.item.mileage != null"
                >Mileage : {{ row6.item.mileage }}<br
              /></span>
              <span v-if="row6.item.toll != '' && row6.item.toll != null"
                >Toll : {{ row6.item.toll }}<br
              /></span>
              <span v-if="row6.item.advanceCash != '' && row6.item.advanceCash != null"
                >Advance Cash : {{ row6.item.advanceCash }}<br
              /></span>
            </template>
            <template slot="isActive" slot-scope="row7">
              <span v-if="row7.item.Status != '' && row7.item.Status != null"
                >{{ row7.item.Status }}<br
              /></span>
            </template>
          </b-table>
        </div>

        <div>
          <h5>
            <div style="text-align: center">
              <b-pagination
                limit="5"
                align="center"
                class="mt-4"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </h5>
        </div>

        <b-modal
          size="lg"
          no-close-on-esc
          no-close-on-backdrop
          ref="Expire-modal"
          hide-footer
          title="Expire Quotation"
        >
          <b-row class="justify-content-center">
            <b-col cols="2" class="mt-2 text-right">
              <label for="ExpiryDate">Expiry Date <span class="error">*</span></label>
            </b-col>
            <b-col cols="10" class="mt-2">
              <date-picker
                :format="selectDateFormat"
                lang="en"
                name="validityDate"
                id="validityDate"
                v-model="validityDate"
                :not-after="max"
              ></date-picker>

              <!-- :not-before="min" -->
              <span class="text-danger" v-if="validityDateErr"></span>
            </b-col>
            <b-col cols="12" class="text-center">
              <b-button
                v-if="validityDate"
                size="sm"
                class="mt-4"
                variant="success"
                @click="UpdateExpiryMultiQuotation('Multi')"
                >Save</b-button
              >
              <b-button
                size="sm"
                class="mt-4"
                variant="outline-danger"
                @click="hideModalExpire"
                >Close</b-button
              >
            </b-col>
          </b-row>
        </b-modal>
        <md-dialog-alert
          :md-content="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-alert>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalContainerValid,
  GlobalGetLocation,
} from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import DateRangePicker from "vue2-daterange-picker";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getPreviousDate();
    if (this.$sessionsStorage.get("userId") == "133") {
      this.$router.push({
        path: "/dashboard",
      });
    }
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({
          itemCode: "PORList",
        })
      );
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
          type: "Normal",
          Territory: "",
        })
      );
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({
          itemCode: "POLList",
        })
      );
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({
          itemCode: "LocationDetailsFinalList",
        })
      );
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewQuotationLibData");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      min: "",
      max: "",
      //Download  Multi Excel Variable Start
      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      ExcelBtnName0: "Export TPT Quotation",
      ExcelBtnName1: "Export FF Quotation",
      ExcelBtnName2: "Export CC Quotation",
      ExcelBtnName3: "Export All Quotation",
      //Download  Multi Excel Variable End

      //Added By Priyanshu Singh Multi Select Start
      validityDate: "",
      validityDateErr: "",
      isCheckAll: false,
      All_tptQIds: [],
      AlltptQSeries: [],
      AllQuotationObjeArr: [],
      selectedAll_tptQIds: "",
      selectedClient_ids: "",
      //Added By Priyanshu Singh Multi Select Start
      PaginationList: [
        {
          pagv: "10",
          pagt: "10",
        },
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        },
      ],
      PaginationCount: "",
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      currentDateValid: new Date().toJSON().slice(0, 10),
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      finalAllPlaceDataPickupLocation: [],
      commodityList: [],
      airlineList: [],
      containerList: [],
      shippingList: [],
      clientTypeFilter: "",
      clientIdFilter: "",
      transportType: "",
      shipmentType: "",
      jobTypeFilter: "",
      enqOrExuFilter: "",
      PORfilter: "",
      PODfilter: "",
      FPODfilter: "",
      LPfilter: "",
      Pickupfilter: "",
      PICKfilter: "",
      STUFFfilter: "",
      HANDfilter: "",
      commodityFilter: "",
      ShippingLineFilter: "",
      enquiryFilter: "",
      QuotationFilter: "",
      fclLclFilter: "",
      airlineFilter: "",
      containerTypeFilter: "",
      tptQuoteFilter: "",
      ccQuoteFilter: "",
      ffQuoteFilter: "",
      visible: false,
      jTypeList: [
        {
          jTypeVal: "TPT",
          jTypeText: "TPT",
        },
        {
          jTypeVal: "FF",
          jTypeText: "FF",
        },
        {
          jTypeVal: "CC",
          jTypeText: "CC",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],

      reload: true,
      clientMaster: [],
      particularStatus: "0",
      name: "BootstrapVue",
      show: true,
      headerFilter: [],
      docURL: URL_BASE_DOC,
      containerNoRegexError: "",
      containerNo: "",
      validContainerNo: "",
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filterClient: "",
      searchValPickup: "",
      searchValHandover: "",
      searchValPOR: "",
      searchValPOD: "",
      searchValLP: "",

      fields: [
        {
          key: "tptTableId",
          mainkey: "tptTableId",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tptQSeries",
          mainkey: "tptQSeries",
          label: "Quotation Details",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry Details",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client/Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "containerType",
          mainkey: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "pickupLocation",
          mainkey: "pickupLocation",
          label: "Location Details",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
        },
        {
          key: "Status",
          mainkey: "Status",
          label: "Other Details",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
        },
        {
          key: "isActive",
          mainkey: "isActive",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      QuotationLibData: [],
      containerTypeList: [],
      statusList: [
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],
      shippingList: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },

  computed: {
    paginatedItems() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.QuotationLibData.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.QuotationLibData.length / this.perPage);
    },
  },
  watch: {},
  methods: {
    nextPage(pageNo) {
      if (this.currentPage < this.totalPages) {
        this.currentPage = pageNo;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getMultiReports(id, type) {
      let payload = {
        itemCode: id,
        dateRange: this.dateRange,
        type: "Excel",
      };
      if (type == 1) {
        this.ExcelBtnName1 = "Downloading Please Wait .....";
      } else if (type == 2) {
        this.ExcelBtnName2 = "Downloading Please Wait .....";
      } else if (type == 3) {
        this.ExcelBtnName0 = "Downloading Please Wait .....";
      }
      CommonService.getAllBLDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              if (type == 1) {
                this.ExcelBtnName1 = "Export FF Quotation";
              } else if (type == 2) {
                this.ExcelBtnName2 = "Export CC Quotation";
              } else if (type == 0) {
                this.ExcelBtnName0 = "Export TPT Quotation";
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
    getReports(id) {
      var excelId = "All_Quotation_Excel";

      if (id == "All_Quotation_Excel") {
        excelId = "All_FF_CC_TPT_Quotation_Excel";
      }
      this.ExcelBtnName3 = "Downloading Please Wait .....";
      let view_Assignment = {
        excelId: excelId,
        clientIdFilter: this.clientIdFilter,
        ShippingLineFilter: this.ShippingLineFilter,
        containerTypeFilter: this.containerTypeFilter,
        Pickupfilter: this.Pickupfilter,
        shipmentType: this.shipmentType,
        transportType: this.transportType,
        fclLclFilter: this.fclLclFilter,
        enquiryFilter: this.enquiryFilter,
        QuotationFilter: this.QuotationFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        FPODfilter: this.FPODfilter,
        LPfilter: this.LPfilter,
        PICKfilter: this.PICKfilter,
        STUFFfilter: this.STUFFfilter,
        HANDfilter: this.HANDfilter,
        airlineFilter: this.airlineFilter,
        Stuffingfilter: "",
        handoverfilter: "",
        dateRange: this.dateRange,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Quotation/getAllQoutationExcel.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ExcelBtnName3 = "Export All Quotation";
            if (data.AllQuotationData.length > 0) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
          }
        })
        .catch((error) => {});
    },
    // getReports(id) {
    //   var excelId = "All_Quotation_Excel";

    //   if (id == "All_Quotation_Excel") {
    //     excelId = "All_Quotation_Excel";
    //   }
    //   this.ExcelBtnName3 = "Downloading Please Wait .....";
    //   let view_Assignment = {
    //     excelId: excelId,
    //     clientIdFilter: this.clientIdFilter,
    //     ShippingLineFilter: this.ShippingLineFilter,
    //     containerTypeFilter: this.containerTypeFilter,
    //     Pickupfilter: this.Pickupfilter,
    //     shipmentType: this.shipmentType,
    //     transportType: this.transportType,
    //     fclLclFilter: this.fclLclFilter,
    //     enquiryFilter: this.enquiryFilter,
    //     QuotationFilter: this.QuotationFilter,
    //     PORfilter: this.PORfilter,
    //     PODfilter: this.PODfilter,
    //     FPODfilter: this.FPODfilter,
    //     LPfilter: this.LPfilter,
    //     PICKfilter: this.PICKfilter,
    //     STUFFfilter: this.STUFFfilter,
    //     HANDfilter: this.HANDfilter,
    //     airlineFilter: this.airlineFilter,
    //     Stuffingfilter: "",
    //     handoverfilter: "",
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_Quotation/getAllQoutationExcel.php`,
    //     data: JSON.stringify(view_Assignment),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if (status == 200 && data) {
    //         this.ExcelBtnName3 = "Export TPT Quotation";
    //         window.location.href =
    //           `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
    //       }
    //     })
    //     .catch((error) => {});
    // },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    pagechangeData() {
      this.perPage = this.PaginationCount;
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.ShippingLineFilter = "";
      this.tptQuoteFilter = "";
      this.ccQuoteFilter = "";
      this.ffQuoteFilter = "";
      this.enquiryFilter = "";
      this.QuotationFilter = "";
      this.fclLclFilter = "";
      this.airlineFilter = "";
      this.containerTypeFilter = "";
      this.clientIdFilter = "";
      this.transportType = "";
      this.shipmentType = "";

      this.PORfilter = "";
      this.PODfilter = "";
      this.FPODfilter = "";
      this.LPfilter = "";
      this.PICKfilter = "";
      this.Pickupfilter = "";
      this.STUFFfilter = "";
      this.HANDfilter = "";
      this.viewFFExportFCL("0", "1", "1");
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },

    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }
      // alert(event)
      this.nextPage(event);
      // this.viewFFExportFCL(CURRENT, "2", event);
    },
    hideModalExpire() {
      this.validityDate = "";
      this.validityDateErr = "";
      this.All_tptQIds = [];
      this.AlltptQSeries = [];
      this.AllQuotationObjeArr = [];
      this.$refs["Expire-modal"].hide();
    },
    ExpiryMultiQuotation() {
      this.$refs["Expire-modal"].show();
    },
    getPreviousDate() {
      const now = new Date();

      const newConst = new Date(new Date().setDate(now.getDate() + 30));
      let dateNo = now.getDate();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const minDate = new Date(today);
      minDate.setMonth(minDate.getMonth() - 2); // one Months
      minDate.setDate(dateNo);
      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() - 1);
      maxDate.setHours(23, 59, 59, 999); // Set to end of the day
      // return maxDate;
      this.min = minDate;
      this.max = maxDate;
    },
    UpdateExpiryMultiQuotation(type) {
      // if (this.validityDate && type) {
      //   this.UpdateExpiryMultiQuotation(type);
      // }
      if (this.validityDate == "") {
        this.validityDateErr = "Expiry Date Field is Required.";
        return false;
      }
      this.isLoading = true;
      if (this.All_tptQIds.length <= 0) {
        this.alert.content = "Please Choose Atleast One Quotations.";
        this.$refs["addPop"].open();
        return false;
      } else if (this.All_tptQIds.length > 0) {
        let payload = {
          ID: this.All_tptQIds,
          Series: this.AlltptQSeries,
          AllQuotationObjeArr: this.AllQuotationObjeArr,
          Type: type,
          validityDate: this.validityDate,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Quotation/expireQotation_VP.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.hideModalExpire();
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    SelectAll: function () {
      console.log("this.QuotationLibData=>", this.QuotationLibData);
      this.isCheckAll = !this.isCheckAll;
      this.All_tptQIds = [];
      this.AlltptQSeries = [];
      this.AllQuotationObjeArr = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.QuotationLibData) {
          let single_data = "";
          this.All_tptQIds.push(this.QuotationLibData[key].QuotId);
          this.AlltptQSeries.push(this.QuotationLibData[key].QuotNo);
          this.AllQuotationObjeArr.push({
            QuotId: this.QuotationLibData[key].QuotId,
            QuotNo: this.QuotationLibData[key].QuotNo,
            quotationType: this.QuotationLibData[key].quotationType,
            mainEnquiryId: this.QuotationLibData[key].mainEnquiryId,
          });
        }
        console.log("this.All_tptQIds=>", this.All_tptQIds);
        console.log("this.AlltptQSeries=>", this.AlltptQSeries);
        console.log("this.AllQuotationObjeArr=>", this.AllQuotationObjeArr);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.All_tptQIds.length == this.QuotationLibData.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }

      const istrue = this.All_tptQIds.includes(item.QuotId);
      if (istrue == true) {
        this.AlltptQSeries.push(item.QuotNo);
        this.AllQuotationObjeArr.push({
          QuotId: item.QuotId,
          QuotNo: item.QuotNo,
          quotationType: item.quotationType,
          mainEnquiryId: item.mainEnquiryId,
        });
      } else {
        const index = this.AlltptQSeries.indexOf(item.QuotNo);
        this.AlltptQSeries.splice(index, 1);
        const indexQuotNo = this.AllQuotationObjeArr.findIndex(
          (obj) => obj.QuotNo === item.QuotNo
        );

        if (indexQuotNo !== -1) {
          this.AllQuotationObjeArr.splice(indexQuotNo, 1);
        }
      }

      console.log("this.All_tptQIds=>", this.All_tptQIds);
      console.log("this.AlltptQSeries=>", this.AlltptQSeries);
      console.log("this.AllQuotationObjeArr=>", this.AllQuotationObjeArr);
    },

    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable({});
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      let payload = {
        excelId: "QuotaionDetailsLib",
        clientIdFilter: this.clientIdFilter,
        ShippingLineFilter: this.ShippingLineFilter,
        containerTypeFilter: this.containerTypeFilter,
        Pickupfilter: this.Pickupfilter,
        shipmentType: this.shipmentType,
        transportType: this.transportType,
        fclLclFilter: this.fclLclFilter,
        enquiryFilter: this.enquiryFilter,
        QuotationFilter: this.QuotationFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        FPODfilter: this.FPODfilter,
        LPfilter: this.LPfilter,
        PICKfilter: this.PICKfilter,
        STUFFfilter: this.STUFFfilter,
        HANDfilter: this.HANDfilter,
        airlineFilter: this.airlineFilter,
        Stuffingfilter: "",
        handoverfilter: "",

        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        dateRange: this.dateRange,
        assignmentNo: "assignmentNo",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Quotation/getAllQoutationExcel.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }

            if (data.QuotationLibData.length > 0) {
              this.QuotationLibData = data.QuotationLibData;
            } else {
              this.QuotationLibData = [];
            }
            console.log("Priyanshu Singh=>", this.QuotationLibData);
            this.isLoading = false;
            if (this.reload == true) {
              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.LocationDetailsTransport.length > 0) {
                this.finalAllPlaceDataPickupLocation = data.LocationDetailsTransport;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
              if (data.airlineList.length > 0) {
                this.airlineList = data.airlineList;
              }
              if (data.containerList.length > 0) {
                this.containerList = data.containerList;
              }
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
            }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.appMargin0 {
  margin-left: 0px !important;
  margin-right: 100px;
  transition: 5s !important;
}
.modal fade show d-block {
  background: none;
}

.btn-outline-success {
  margin-bottom: 0.5rem;
}
.btn-outline-danger {
  margin-bottom: 0.5rem;
}
@media (max-width: 944px) {
  .md-flex-small-100 {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// viewAllQoutation.vue?95b56844